window.addEventListener('DOMContentLoaded', () => {
  var item = document.getElementsByClassName('item-slider');
    if(document.querySelector('#container-slider-home')){
      tns({
          "container": "#container-slider-home",
          "items": item.length < 4 ? item.length : 4,
          "navAsThumbnails": true,
          "autoplay": false,
          "autoplayTimeout": 5000,
          "swipeAngle": false,
          "speed": 400,
          "controlsContainer": "#customize-controls",
          "responsive": {
            "320": {
              "items": 1
            },
            "500": {
              "items": 2
            },
            "768": {
              "items": 3
            },
            "1024": {
              "items":  item.length < 4 ? item.length : 4
            }
          },
      });
  }
});